// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/images/infrastructure-img/infrastructure_herobg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../public/images/infrastructure-img/infrastructure_herobg_light.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../public/images/infrastructure-img/why_institutionsbg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../public/images/infrastructure-img/why_institutionsbg_light.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../../public/images/infrastructure-img/built_diligencebg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../../public/images/infrastructure-img/built_diligencebg_light.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   AGCX SETTLEMENT INFRASTRUCTURE PAGE STYLES
   ========================================================================== */

.infrastructure-page-wrapper {
  background-color: #0b0d12;
  color: #ffffff;
  position: relative;
  min-height: 100vh;
  font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  overflow-x: hidden;
}

body.light_theme .infrastructure-page-wrapper {
  background-color: #ffffff;
  color: #0f172a;
}

/* ==========================================================================
   1. HERO SECTION
   ========================================================================== */
.inst-hero-section {
  position: relative;
  width: 100%;
  background-color: #0b0d12;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center top;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 110px 0px 90px;
  overflow: hidden;
  color: #ffffff;
  border-bottom-left-radius: 36px;
  border-bottom-right-radius: 36px;
}

body.light_theme .inst-hero-section {
  background-color: #f8fafc;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  color: #0f172a;
}

.inst-hero-container {
  position: relative;
  z-index: 2;
  max-width: 1480px;
  padding: 0px 20px;
  justify-content: space-between;
  width: 100%;
  display: flex;
  gap: 30px;
  align-items: center;
}

.inst-hero-content {
  max-width: 760px;
}

.inst-hero-title {
  font-size: 72px;
  font-weight: 700;
  line-height: 1.12;
  color: #ffffff;
  margin-bottom: 1.6rem;
}

body.light_theme .inst-hero-title {
  color: #0f172a;
}

.inst-hero-description {
  font-size: 24px;
  line-height: 1.65;
  color: #9ca3af;
  max-width: 100%;
  margin-bottom: 2.2rem;
  font-weight: 400;
}

body.light_theme .inst-hero-description {
  color: #475569;
}

.inst-hero-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
}

.inst-hero-actions button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 600;
  gap: 8px;
  padding: 18px 32px;
  border-radius: 9999px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  text-decoration: none;
}

.inst-hero-actions .inst-btn-primary {
  background: #D1AA67;
  color: #fff;
  border: none;
  font-weight: 400;
}

.inst-btn-primary:hover {
  transform: translateY(-2px);
  background: #deb978;
  box-shadow: 0 6px 25px rgba(209, 170, 103, 0.45);
}

.inst-btn-secondary {
  background: rgba(82, 82, 82, 0.85);
  color: #e5e7eb !important;
  -webkit-backdrop-filter: blur(8px);
          backdrop-filter: blur(8px);
}

body.light_theme .inst-btn-secondary {
  background: rgba(0, 0, 0, 0.06);
  color: #1e293b !important;
  border-color: rgba(0, 0, 0, 0.12) !important;
}

.inst-btn-secondary:hover {
  background: rgba(110, 110, 110, 0.95);
  transform: translateY(-2px);
  color: #ffffff !important;
}

.inst-hero-graphic {
  position: relative;
  width: 600px;
  max-width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}

.inst-hero-img {
  width: 100%;
  max-width: 580px;
  height: auto;
  object-fit: contain;
  filter: drop-shadow(0 20px 40px rgba(0, 0, 0, 0.6));
  animation: floatHeroGraphic 6s ease-in-out infinite alternate;
}

@keyframes floatHeroGraphic {
  0% {
    transform: translateY(0px);
  }

  100% {
    transform: translateY(-8px);
  }
}

/* ==========================================================================
   2. WHY INSTITUTIONS CHOOSE AGCX SECTION
   ========================================================================== */
.inst-why-section {
  position: relative;
  width: 100%;
  background-color: #0b0d12;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  padding: 100px 0px 120px;
  overflow: hidden;
  color: #ffffff;
}

body.light_theme .inst-why-section {
  background-color: #ffffff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  color: #0f172a;
}

.inst-why-container {
  position: relative;
  z-index: 2;
  padding: 0px 20px;
  max-width: 1480px;
  margin: 0 auto;
}

.inst-why-title {
  font-size: 60px;
  font-weight: 600;
  line-height: 1.2;
  background: linear-gradient(135deg, #ffffff 0%, #fce7ca 50%, #D1AA67 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-align: center;
  margin-bottom: 60px;
}

body.light_theme .inst-why-title {
  background: linear-gradient(135deg, #000000 0%, #73562e 50%, #D1AA67 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.inst-why-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 36px;
}

.inst-why-card {
  position: relative;
  width: 100%;
  min-height: 440px;
  background: linear-gradient(180deg, rgba(35, 38, 43, 1) 0%, rgba(23, 26, 32, 1) 100%);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  padding: 36px 28px 34px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  overflow: hidden;
  -webkit-backdrop-filter: blur(12px);
          backdrop-filter: blur(12px);
  transition: transform 0.35s cubic-bezier(0.16, 1, 0.3, 1), border-color 0.35s ease, box-shadow 0.35s ease;
}

body.light_theme .inst-why-card {
  background: #F0F0F0;
  border: 1px solid #e2e8f0;
  box-shadow: 0 10px 30px rgb(0 0 0 / 6%);
}

.inst-why-card:hover {
  transform: translateY(-6px);
  border-color: rgba(212, 164, 96, 0.4);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5), 0 0 25px rgba(212, 164, 96, 0.12);
}

.inst-why-card-pattern {
  position: absolute;
  top: 0;
  left: -10%;
  width: 100%;
  max-width: 480px;
  height: 200px;
  object-fit: contain;
  object-position: top center;
  pointer-events: none;
  z-index: 1;
  opacity: 1;
}

.inst-why-badge-wrap {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
}

.inst-why-vector-img {
  width: 200px;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.inst-why-card:hover .inst-why-vector-img {
  transform: scale(1.06);
}

.inst-why-card-title {
  position: relative;
  z-index: 2;
  font-size: 28px;
  font-weight: 600;
  color: #ffffff;
  line-height: 1.25;
  text-align: center;
  width: 100%;
  min-height: 54px;
  margin: 0 auto 15px;
}

body.light_theme .inst-why-card-title {
  color: #0f172a;
}

.inst-why-card-desc {
  position: relative;
  z-index: 2;
  font-size: 14px;
  font-weight: 400;
  color: #A8ABB4;
  line-height: 1.6;
  text-align: center;
  max-width: 360px;
  margin: 0 auto;
}

body.light_theme .inst-why-card-desc {
  color: #64748b;
}

/* ==========================================================================
   3. BUILT TO PASS YOUR DUE DILIGENCE SECTION
   ========================================================================== */
.inst-due-section {
  position: relative;
  padding: 90px 0px 100px;
  background-color: #171A20;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  overflow: hidden;
  color: #ffffff;
}

body.light_theme .inst-due-section {
  background-color: #f8fafc;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  color: #0f172a;
}

.inst-due-container {
  position: relative;
  z-index: 2;
  max-width: 1480px;
  padding: 0px 20px;
  margin: 0 auto;
}

.inst-due-header-grid {
  display: grid;
  grid-template-columns: 1.15fr 0.85fr;
  align-items: center;
  gap: 40px;
  margin-bottom: 58px;
}

.inst-due-title {
  font-size: 60px;
  font-weight: 700;
  line-height: 1.15;
  color: #ffffff;
  margin-bottom: 18px;
}

body.light_theme .inst-due-title {
  color: #0f172a;
}

.inst-due-gold {
  color: #D1AA67;
}

.inst-due-subtitle {
  font-size: 22px;
  line-height: 1.65;
  color: #94A3B8;
  max-width: 580px;
  margin: 0;
}

body.light_theme .inst-due-subtitle {
  color: #475569;
}

.inst-due-graphic-wrap {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.inst-due-svg {
  width: 100%;
  max-width: 550px;
  height: auto;
  object-fit: contain;
}

.inst-due-cards-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;
  align-items: stretch;
}

.inst-due-card {
  position: relative;
  background: rgb(255 255 255 / 10%);
  border: 1px solid rgba(255, 255, 255, 0.20);
  border-radius: 18px;
  min-height: 341px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  -webkit-backdrop-filter: blur(12px);
  backdrop-filter: blur(12px);
  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1), border-color 0.3s ease, box-shadow 0.3s ease;
}

body.light_theme .inst-due-card {
  background: #ffffff;
  border: 1px solid #f2f2f2;
  box-shadow: 0 8px 24px rgb(0 0 0 / 12%);
}

.inst-due-card:hover {
  transform: translateY(28px);
  background: #D1AA67;
  border: 1px solid rgba(255, 255, 255, 0.3);
  z-index: 3;
}

body.light_theme .inst-due-card:hover .cards_buitseffect {
  background-color: rgb(0 0 0 / 5%);
  border: 1px solid #e8e8e8;
}

.cards_buitseffect {
  padding: 20px;
  border-radius: 16px;
  background-color: rgb(255 255 255 / 0%);
  border: 1px solid #ffffff00;
  height: 100%;
}

.inst-due-card:hover .cards_buitseffect {
  background-color: rgb(255 255 255 / 10%);
  border: 1px solid #fff;
}

.inst-due-card:hover .inst-due-icon-badge {
  background-color: #fff;
}

.inst-due-card:hover .inst-due-icon-badge img {
  filter: invert(1);
}

.inst-due-card:hover .inst-due-card-desc {
  color: #ffffff;
}

.inst-due-dots-badge {
  position: absolute;
  top: 14px;
  left: 18px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  letter-spacing: 2px;
  font-weight: 700;
}

.inst-due-icon-badge {
  width: 48px;
  height: 48px;
  background: #D1AA67;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 32px;
}

.inst-due-icon-img {
  width: 26px;
  height: 26px;
  object-fit: contain;
}

.inst-due-card-title {
  font-size: 24px;
  font-weight: 600;
  color: #ffffff;
  line-height: 1.3;
  margin-bottom: 18px;
}

body.light_theme .inst-due-card-title {
  color: #0f172a;
}

.inst-due-card-featured .inst-due-card-title {
  color: #ffffff;
}

.inst-due-card-desc {
  font-size: 16px;
  line-height: 1.6;
  color: #a6a6a6;
  margin: 0;
}

body.light_theme .inst-due-card-desc {
  color: #64748b;
}

body.light_theme .inst-due-card:hover .inst-due-card-desc {
  color: #64748b;
}

body.light_theme .inst-due-card:hover .inst-due-icon-badge {
  background-color: #dddddd;
}

.inst-due-card-featured .inst-due-card-desc {
  color: rgba(255, 255, 255, 0.95);
}

/* ==========================================================================
   4. INSTITUTIONAL SOLUTIONS FOR EVERY MARKET SECTION
   ========================================================================== */
.inst-sol-section {
  position: relative;
  padding: 70px 0px 120px;
  background: #171A20;
  color: #ffffff;
  overflow: hidden;
}

body.light_theme .inst-sol-section {
  background-color: #ffffff;
  color: #0f172a;
}

.inst-sol-container {
  position: relative;
  z-index: 2;
  max-width: 1480px;
  margin: 0 auto;
  padding: 0px 20px;
}

.inst-sol-grid {
  display: grid;
  grid-template-columns: 1fr 1.20fr;
  gap: 42px;
  align-items: center;
}

.inst-sol-graphic-col {
  display: flex;
  justify-content: center;
  align-items: center;
}

.inst-sol-graphic-wrap {
  position: relative;
  width: 100%;
  max-width: 660px;
}

.inst-sol-img {
  width: 100%;
  height: auto;
  display: block;
  object-fit: contain;
  filter: drop-shadow(0 20px 40px rgba(0, 0, 0, 0.4));
}

.inst-sol-text-col {
  display: flex;
  flex-direction: column;
}

.inst-sol-title {
  font-size: 60px;
  font-weight: 500;
  line-height: 1;
  color: #ffffff;
  margin-bottom: 36px;
}

body.light_theme .inst-sol-title {
  color: #0f172a;
}

.inst-sol-gold {
  color: #D1AA67;
  font-weight: 700;
}

.inst-sol-table {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.inst-sol-table-header {
  display: grid;
  grid-template-columns: 270px 1fr;
  padding-bottom: 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 18px;
  font-weight: 500;
}

body.light_theme .inst-sol-table-header {
  border-color: #e2e8f0;
}

.inst-sol-th-left {
  color: #D1AA67;
}

.inst-sol-th-right {
  color: #D1AA67;
}

.inst-sol-row {
  display: grid;
  grid-template-columns: 270px 1fr;
  align-items: center;
  padding: 18px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  transition: background 0.2s ease;
}

body.light_theme .inst-sol-row {
  border-color: #f1f5f9;
}

.inst-sol-row:hover {
  background: rgba(255, 255, 255, 0.015);
}

.inst-sol-row:last-child {
  border-bottom: none;
}

.inst-sol-cell-institution {
  display: flex;
  align-items: center;
  gap: 14px;
  padding-right: 16px;
}

.inst-sol-icon-badge {
  width: 46px;
  min-width: 46px;
  height: 46px;
  border-radius: 50%;
  background: rgb(255 255 255 / 10%);
  border: 1px solid rgb(255 255 255 / 18%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.inst-sol-icon-img {
  width: 30px;
  object-fit: contain;
}

.inst-sol-inst-name {
  font-size: 18px;
  font-weight: 500;
  color: #ffffff;
  line-height: 1.3;
}

body.light_theme .inst-sol-inst-name {
  color: #0f172a;
}

.inst-sol-cell-desc {
  font-size: 18px;
  line-height: 1.55;
  color: #A7A7A7;
}

body.light_theme .inst-sol-cell-desc {
  color: #475569;
}

/* ==========================================================================
   5. PROCESS BANNER
   ========================================================================== */
.inst-proc-banner {
  margin-top: 70px;
  background: rgb(255 255 255 / 5%);
  border: 1px solid rgb(209 170 103 / 25%);
  border-radius: 18px;
  padding: 40px;
  display: grid;
  grid-template-columns: 420px 1fr;
  gap: 40px;
  align-items: center;
  /* box-shadow: 0 20px 50px rgba(0, 0, 0, 0.4), inset 0 1px 1px rgba(255, 255, 255, 0.06); */
  position: relative;
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
}

body.light_theme .inst-proc-banner {
  background: rgb(0 0 0 / 5%);
  border: 1px solid rgb(209 170 103 / 25%);
  box-shadow: 0 10px 30px rgb(0 0 0 / 18%);
}

.inst-proc-left {
  display: flex;
  flex-direction: column;
}

.inst-proc-title {
  font-size: 36px;
  font-weight: 800;
  line-height: 1.18;
  color: #ffffff;
  margin: 0 0 16px 0;
}

body.light_theme .inst-proc-title {
  color: #0f172a;
}

.inst-proc-gold {
  color: #D1AA67;
}

.inst-proc-desc {
  font-size: 16px;
  line-height: 1.55;
  color: #94A3B8;
  margin: 0;
}

body.light_theme .inst-proc-desc {
  color: #64748b;
}

.inst-proc-steps {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  align-items: flex-start;
}

.inst-proc-step {
  display: flex;
  flex-direction: column;
}

.inst-proc-icon-wrap {
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
  position: relative;
}

.inst-proc-icon {
  width: 52px;
  min-width: 52px;
  height: 52px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.10);
  border: 1px solid rgba(255, 255, 255, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: inset 0 1px 1px rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

body.light_theme .inst-sol-icon-badge {
  background: rgb(132 132 132 / 10%);
}

body.light_theme .inst-proc-icon {
  background: rgb(0 0 0 / 5%);
  border-color: #e7e7e7;
}

body.light_theme .inst-cta-arch {
  background: radial-gradient(ellipse at 50% 0%, rgba(212, 164, 96, 0.40) 0%, rgb(255 255 255 / 40%) 50%, rgb(255 255 255 / 0%) 80%);
}

.inst-proc-step:hover .inst-proc-icon {
  background: rgba(212, 164, 96, 0.12);
  border-color: rgba(212, 164, 96, 0.4);
  box-shadow: 0 0 18px rgba(212, 164, 96, 0.25);
  transform: scale(1.06);
}

.inst-proc-connector {
  flex: 1 1;
  height: 1px;
  background: linear-gradient(90deg, rgba(212, 164, 96, 0.4), rgba(255, 255, 255, 0.1));
  margin-left: 14px;
}

.inst-proc-step-title {
  font-size: 18px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 10px 0;
}

body.light_theme .inst-proc-step-title {
  color: #0f172a;
}

.inst-proc-step-desc {
  font-size: 15px;
  line-height: 1.5;
  color: #94A3B8;
  margin: 0;
}

body.light_theme .inst-proc-step-desc {
  color: #64748b;
}

/* ==========================================================================
   6. SETTLEMENT CTA BOX
   ========================================================================== */
.inst-cta-box {
  margin-top: 100px;
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 140px 20px 40px;
  overflow: hidden;
}

.inst-cta-arch {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: min(1360px, 100%);
  height: 600px;
  border-radius: 50% 50% 0 0 / 100% 100% 0 0;
  border-top: 1.5px solid rgba(212, 164, 96, 0.45);
  border-left: 1px solid rgba(212, 164, 96, 0.15);
  border-right: 1px solid rgba(212, 164, 96, 0.15);
  border-bottom: none;
  background: radial-gradient(ellipse at 50% 0%, rgba(212, 164, 96, 0.32) 0%, rgba(25, 27, 36, 0.4) 50%, rgba(11, 12, 16, 0) 80%);
  pointer-events: none;
}

.inst-cta-content {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 680px;
}

.inst-cta-title {
  font-size: 60px;
  font-weight: 600;
  line-height: 1.15;
  color: #ffffff;
  margin: 0 0 12px 0;
}

body.light_theme .inst-cta-title {
  color: #0f172a;
}

.inst-cta-subtitle {
  font-size: 24px;
  line-height: 1.55;
  color: #9CA3AF;
  margin: 0 0 30px 0;
  max-width: 800px;
}

body.light_theme .inst-cta-subtitle {
  color: #475569;
}

.inst-cta-btns {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
}

.inst-cta-btns button {
  font-size: 20px;
  font-weight: 600;
  padding: 18px 35px;
  border-radius: 100px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
}

.inst-cta-btn-primary {
  background: #d1aa67;
  color: #0b0c10;

}

.inst-cta-btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 28px rgba(212, 164, 96, 0.45);
  background: #deb978;
}

.inst-cta-btn-secondary {
  background: #737373;
  color: #ffffff;
}

body.light_theme .inst-cta-btn-secondary {
  background: rgba(0, 0, 0, 0.05);
  color: #1e293b;
  border-color: rgba(0, 0, 0, 0.1);
}

.inst-cta-btn-secondary:hover {
  transform: translateY(-2px);
  background: rgba(110, 110, 110, 0.95);
  border-color: rgba(255, 255, 255, 0.35);
}

/* ==========================================================================
   RESPONSIVE STYLES
   ========================================================================== */

@media (max-width: 1500px) {

  .inst-hero-title {
    font-size: 64px;
  }

  .inst-hero-description {
    font-size: 22px;
  }

  .inst-hero-container {
    max-width: 95%;
  }

  .inst-due-container {
    max-width: 95%;
  }

  .inst-sol-container {
    max-width: 95%;
  }

  .inst-cta-title {
    font-size: 54px;
  }

  .inst-why-title {
    font-size: 54px;
  }

  .inst-due-title {
    font-size: 54px;
  }

  .inst-sol-title {
    font-size: 54px;
  }

  .inst-why-container {
    max-width: 95%;
  }

}


@media (max-width: 1376px) {

  .inst-hero-section {
    padding: 40px 0px 50px;
    min-height: 80vh;
  }

  .inst-hero-title {
    font-size: 54px;
  }

  .inst-hero-description {
    font-size: 18px;
    margin-bottom: 24px;
  }

  .inst-hero-actions button {
    font-size: 15px;
    padding: 13px 24px;
  }

  .inst-cta-title {
    font-size: 48px;
  }

  .inst-why-title {
    font-size: 48px;
  }

  .inst-due-title {
    font-size: 48px;
  }

  .inst-sol-title {
    font-size: 48px;
  }

  .inst-due-subtitle {
    font-size: 18px;
  }

  .inst-cta-btns button {
    font-size: 16px;
    padding: 14px 32px;
  }

  .inst-cta-subtitle {
    font-size: 20px;
    margin: 0 0 24px 0;
  }

}


@media (max-width: 1200px) {


  .inst-due-cards-grid {
    grid-template-columns: repeat(3, 1fr);
  }

  .inst-due-card-featured {
    transform: none;
  }

  .inst-due-card-featured:hover {
    transform: translateY(-5px);
  }

  .inst-proc-banner {
    grid-template-columns: 1fr;
    gap: 36px;
    padding: 36px 32px;
  }
}

@media (max-width: 1200px) {


  .inst-hero-container {
    gap: 24px;
  }

  .inst-hero-title {
    font-size: 42px;
  }


  .inst-hero-img {
    max-width: 400px;
  }

  .inst-hero-content {
    max-width: 100%;
  }

  .inst-hero-section {
    padding: 40px 0px !important;
  }

  .inst-hero-description {
    margin-left: auto;
    margin-right: auto;
  }

  .inst-hero-actions button {
    font-size: 14px;
    padding: 12px 18px;
  }

  .inst-why-title {
    font-size: 40px;
    margin-bottom: 32px;
  }

  .inst-hero-graphic {
    width: auto;
  }

  .inst-why-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }

  .inst-sol-grid {
    gap: 24px;
  }

  .inst-sol-title {
    font-size: 36px;
  }

  .inst-why-section {
    padding: 60px 0px 80px;
  }

  .inst-due-title {
    font-size: 40px;
  }

  .inst-due-section {
    padding: 60px 0px 60px;
  }

  .inst-sol-section {
    padding: 60px 0px 70px;
  }

  .inst-sol-cell-desc {
    font-size: 15px;
  }

  .inst-sol-inst-name {
    font-size: 15px;
  }

  .inst-cta-title {
    font-size: 40px;
  }

  .inst-cta-subtitle {
    font-size: 18px;
  }

}

@media (max-width: 991px) {

  .inst-hero-img {
    max-width: 300px;
  }

  .inst-hero-title {
    font-size: 36px;
    margin-bottom: 18px;
  }

  .inst-hero-description {
    font-size: 16px;
  }

  .inst-hero-container {
    max-width: 100%;
  }

  .inst-why-title {
    font-size: 32px;
    margin-bottom: 24px;
  }

  .inst-why-card-title {
    font-size: 20px;
    min-height: 48px;
  }

  .inst-why-vector-img {
    width: 150px;
  }

  .inst-why-container {
    max-width: 100%;
  }

  .inst-due-title {
    font-size: 32px;
  }

  .inst-due-subtitle {
    font-size: 16px;
  }

  .inst-due-svg {
    max-width: 400px;
  }

  .inst-sol-grid {
    display: flex;
    flex-direction: column-reverse;
  }

  .inst-sol-graphic-wrap {
    max-width: 400px;
  }

  .inst-proc-title {
    font-size: 32px;
  }

  .inst-due-header-grid {
    grid-template-columns: 1fr;
    gap: 30px;
    text-align: center;
  }

  .inst-due-subtitle {
    margin: 0 auto;
  }

  .inst-due-graphic-wrap {
    justify-content: center;
  }

  .inst-due-cards-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .inst-proc-steps {
    grid-template-columns: repeat(2, 1fr);
    gap: 28px;
  }

  .inst-proc-connector {
    display: none;
  }
}

@media (max-width: 768px) {
  .inst-cta-box {
    margin-top: 60px;
    padding: 60px 16px 40px;
  }

  .inst-cta-title {
    font-size: 30px;
  }

  .inst-cta-subtitle {
    font-size: 14px;
    margin-bottom: 28px;
  }

  .inst-cta-btns {
    flex-wrap: nowrap;
  }

  .inst-cta-btn-primary,
  .inst-cta-btn-secondary {
    width: 100%;
  }

  .inst-cta-btns button {
    font-size: 15px;
    padding: 12px 18px;
  }

  .inst-cta-arch {
    height: 280px;
  }
}

@media (max-width: 767px) {

  .inst-hero-container {
    flex-direction: column;
    text-align: center;
    gap: 32px;
  }

  body #hero.inst-hero-section {
    padding: 32px 0px !important;
    border-radius: 0px;
  }

  .inst-why-section {
    padding: 35px 0px 40px;
  }

  .inst-hero-title {
    font-size: 26px;
    margin-bottom: 14px;
  }

  .inst-hero-img {
    max-width: 280px;
  }

  .inst-why-grid {
    grid-template-columns: 1fr;
  }

  .inst-sol-section {
    padding: 35px 0px;
  }

  .inst-why-title {
    font-size: 24px;
    margin-bottom: 22px;
  }

  .inst-why-card {
    padding: 24px;
  }

  .inst-sol-title {
    font-size: 24px;
    margin-bottom: 18px;
    text-align: center;
  }

  .inst-sol-table-header {
    display: none;
  }

  .inst-sol-row {
    grid-template-columns: 1fr;
    gap: 10px;
    padding: 16px 0;
  }

  .inst-due-cards-grid {
    grid-template-columns: 1fr;
  }

  .inst-due-section {
    padding: 35px 0px 35px;
  }

  .inst-proc-steps {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .inst-sol-cell-desc {
    font-size: 14px;
  }

  .inst-sol-graphic-wrap {
    max-width: 280px;
  }

  .inst-proc-banner {
    gap: 24px;
    padding: 24px;
    text-align: center;
    margin-top: 40px;
  }

  .inst-proc-icon-wrap {
    justify-content: center;
    margin-bottom: 15px;
  }

  .inst-due-card-title {
    font-size: 20px;
    margin-bottom: 12px;
  }

  .inst-due-card-desc {
    font-size: 14px;
  }

  .inst-cta-arch {
    border-radius: 0px;
    border: none;
  }

  .inst-cta-box {
    margin-top: 40px;
    padding: 24px 16px 24px;
  }

  .inst-cta-title {
    font-size: 24px;
  }

  .inst-cta-subtitle {
    margin-bottom: 18px;
  }

  .inst-proc-title {
    font-size: 24px;
  }

  .inst-proc-desc {
    font-size: 15px;
  }

  .inst-due-title {
    font-size: 24px;
  }

  .inst-due-subtitle {
    font-size: 15px;
  }

  .inst-due-header-grid {
    gap: 24px;
    margin-bottom: 26px;
  }

  .inst-due-container {
    max-width: 100%;
  }

  .inst-sol-container {
    max-width: 100%;
  }

  .inst-hero-actions {
    justify-content: center;
  }


}

@media (max-width:480px) {

  .inst-cta-btns {
    flex-direction: column;
    gap: 12px;
  }

  .inst-cta-btns button {
    font-size: 14px;
    padding: 10px 18px;
  }

  .inst-sol-row {
    text-align: center;
  }

  .inst-sol-cell-institution {
    justify-content: center;
    flex-direction: column;
    padding-right: 0px;
  }

  .inst-hero-title {
    font-size: 24px;
  }

  .inst-hero-description {
    font-size: 15px;
    margin-bottom: 12px;
  }

  .inst-why-title {
    font-size: 22px;
    margin-bottom: 18px;
  }

  .inst-why-card-title {
    font-size: 18px;
    min-height: auto;
  }

  .inst-due-title {
    font-size: 22px;
    margin-bottom: 12px;
  }

  .inst-due-card-title {
    font-size: 18px;
  }

  .inst-due-icon-badge {
    margin-bottom: 20px;
  }

  .inst-sol-title {
    font-size: 22px;
  }

  .inst-proc-title {
    font-size: 22px;
  }

}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/Infrastructure/infrastructure.css"],"names":[],"mappings":"AAAA;;+EAE+E;;AAE/E;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,kGAAkG;EAClG,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;+EAE+E;AAC/E;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,yDAA+F;EAC/F,4BAA4B;EAC5B,+BAA+B;EAC/B,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,yDAAqG;EACrG,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,iBAAiB;EACjB,8BAA8B;EAC9B,WAAW;EACX,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,QAAQ;EACR,kBAAkB;EAClB,qBAAqB;EACrB,2CAA2C;EAC3C,eAAe;EACf,kDAAkD;EAClD,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,kCAA0B;UAA1B,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,mDAAmD;EACnD,6DAA6D;AAC/D;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;;+EAE+E;AAC/E;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,yDAA4F;EAC5F,4BAA4B;EAC5B,kCAAkC;EAClC,sBAAsB;EACtB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yDAAkG;EAClG,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,0EAA0E;EAC1E,6BAA6B;EAC7B,oCAAoC;EACpC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,0EAA0E;EAC1E,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,qFAAqF;EACrF,2CAA2C;EAC3C,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mCAA2B;UAA3B,2BAA2B;EAC3B,yGAAyG;AAC3G;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,6EAA6E;AAC/E;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;EACpB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;+EAE+E;AAC/E;EACE,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,yDAA2F;EAC3F,4BAA4B;EAC5B,kCAAkC;EAClC,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yDAAiG;EACjG,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,2CAA2C;EAC3C,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mCAAmC;EACnC,2BAA2B;EAC3B,sGAAsG;AACxG;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,0CAA0C;EAC1C,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uCAAuC;EACvC,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,+BAA+B;EAC/B,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;+EAE+E;AAC/E;EACE,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,oBAAoB;EACpB,iDAAiD;EACjD,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;EACf,kDAAkD;EAClD,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;+EAE+E;AAC/E;EACE,gBAAgB;EAChB,iCAAiC;EACjC,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;EACnB,2FAA2F;EAC3F,kBAAkB;EAClB,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,kIAAkI;AACpI;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,6CAA6C;EAC7C,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,qFAAqF;EACrF,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;;+EAE+E;AAC/E;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,wBAAwB;EACxB,aAAa;EACb,0CAA0C;EAC1C,gDAAgD;EAChD,+CAA+C;EAC/C,gDAAgD;EAChD,mBAAmB;EACnB,+HAA+H;EAC/H,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;;AAEhB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;;+EAE+E;;AAE/E;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;AAEF;;;AAGA;;EAEE;IACE,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;AAEF;;;AAGA;;;EAGE;IACE,qCAAqC;EACvC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,kBAAkB;EACpB;AACF;;AAEA;;;EAGE;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;;EAGA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;AAEF;;AAEA;;EAEE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;;EAEE;IACE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,4BAA4B;IAC5B,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,SAAS;IACT,aAAa;IACb,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;;AAGF;;AAEA;;EAEE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;AAEF","sourcesContent":["/* ==========================================================================\n   AGCX SETTLEMENT INFRASTRUCTURE PAGE STYLES\n   ========================================================================== */\n\n.infrastructure-page-wrapper {\n  background-color: #0b0d12;\n  color: #ffffff;\n  position: relative;\n  min-height: 100vh;\n  font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n  overflow-x: hidden;\n}\n\nbody.light_theme .infrastructure-page-wrapper {\n  background-color: #ffffff;\n  color: #0f172a;\n}\n\n/* ==========================================================================\n   1. HERO SECTION\n   ========================================================================== */\n.inst-hero-section {\n  position: relative;\n  width: 100%;\n  background-color: #0b0d12;\n  background-image: url('../../../../public/images/infrastructure-img/infrastructure_herobg.jpg');\n  background-repeat: no-repeat;\n  background-position: center top;\n  background-size: cover;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 110px 0px 90px;\n  overflow: hidden;\n  color: #ffffff;\n  border-bottom-left-radius: 36px;\n  border-bottom-right-radius: 36px;\n}\n\nbody.light_theme .inst-hero-section {\n  background-color: #f8fafc;\n  background-image: url('../../../../public/images/infrastructure-img/infrastructure_herobg_light.jpg');\n  color: #0f172a;\n}\n\n.inst-hero-container {\n  position: relative;\n  z-index: 2;\n  max-width: 1480px;\n  padding: 0px 20px;\n  justify-content: space-between;\n  width: 100%;\n  display: flex;\n  gap: 30px;\n  align-items: center;\n}\n\n.inst-hero-content {\n  max-width: 760px;\n}\n\n.inst-hero-title {\n  font-size: 72px;\n  font-weight: 700;\n  line-height: 1.12;\n  color: #ffffff;\n  margin-bottom: 1.6rem;\n}\n\nbody.light_theme .inst-hero-title {\n  color: #0f172a;\n}\n\n.inst-hero-description {\n  font-size: 24px;\n  line-height: 1.65;\n  color: #9ca3af;\n  max-width: 100%;\n  margin-bottom: 2.2rem;\n  font-weight: 400;\n}\n\nbody.light_theme .inst-hero-description {\n  color: #475569;\n}\n\n.inst-hero-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 16px;\n}\n\n.inst-hero-actions button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  font-weight: 600;\n  gap: 8px;\n  padding: 18px 32px;\n  border-radius: 9999px;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  cursor: pointer;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n  text-decoration: none;\n}\n\n.inst-hero-actions .inst-btn-primary {\n  background: #D1AA67;\n  color: #fff;\n  border: none;\n  font-weight: 400;\n}\n\n.inst-btn-primary:hover {\n  transform: translateY(-2px);\n  background: #deb978;\n  box-shadow: 0 6px 25px rgba(209, 170, 103, 0.45);\n}\n\n.inst-btn-secondary {\n  background: rgba(82, 82, 82, 0.85);\n  color: #e5e7eb !important;\n  backdrop-filter: blur(8px);\n}\n\nbody.light_theme .inst-btn-secondary {\n  background: rgba(0, 0, 0, 0.06);\n  color: #1e293b !important;\n  border-color: rgba(0, 0, 0, 0.12) !important;\n}\n\n.inst-btn-secondary:hover {\n  background: rgba(110, 110, 110, 0.95);\n  transform: translateY(-2px);\n  color: #ffffff !important;\n}\n\n.inst-hero-graphic {\n  position: relative;\n  width: 600px;\n  max-width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.inst-hero-img {\n  width: 100%;\n  max-width: 580px;\n  height: auto;\n  object-fit: contain;\n  filter: drop-shadow(0 20px 40px rgba(0, 0, 0, 0.6));\n  animation: floatHeroGraphic 6s ease-in-out infinite alternate;\n}\n\n@keyframes floatHeroGraphic {\n  0% {\n    transform: translateY(0px);\n  }\n\n  100% {\n    transform: translateY(-8px);\n  }\n}\n\n/* ==========================================================================\n   2. WHY INSTITUTIONS CHOOSE AGCX SECTION\n   ========================================================================== */\n.inst-why-section {\n  position: relative;\n  width: 100%;\n  background-color: #0b0d12;\n  background-image: url('../../../../public/images/infrastructure-img/why_institutionsbg.jpg');\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: cover;\n  padding: 100px 0px 120px;\n  overflow: hidden;\n  color: #ffffff;\n}\n\nbody.light_theme .inst-why-section {\n  background-color: #ffffff;\n  background-image: url('../../../../public/images/infrastructure-img/why_institutionsbg_light.jpg');\n  color: #0f172a;\n}\n\n.inst-why-container {\n  position: relative;\n  z-index: 2;\n  padding: 0px 20px;\n  max-width: 1480px;\n  margin: 0 auto;\n}\n\n.inst-why-title {\n  font-size: 60px;\n  font-weight: 600;\n  line-height: 1.2;\n  background: linear-gradient(135deg, #ffffff 0%, #fce7ca 50%, #D1AA67 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  text-align: center;\n  margin-bottom: 60px;\n}\n\nbody.light_theme .inst-why-title {\n  background: linear-gradient(135deg, #000000 0%, #73562e 50%, #D1AA67 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.inst-why-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 36px;\n}\n\n.inst-why-card {\n  position: relative;\n  width: 100%;\n  min-height: 440px;\n  background: linear-gradient(180deg, rgba(35, 38, 43, 1) 0%, rgba(23, 26, 32, 1) 100%);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 20px;\n  padding: 36px 28px 34px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  overflow: hidden;\n  backdrop-filter: blur(12px);\n  transition: transform 0.35s cubic-bezier(0.16, 1, 0.3, 1), border-color 0.35s ease, box-shadow 0.35s ease;\n}\n\nbody.light_theme .inst-why-card {\n  background: #F0F0F0;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 10px 30px rgb(0 0 0 / 6%);\n}\n\n.inst-why-card:hover {\n  transform: translateY(-6px);\n  border-color: rgba(212, 164, 96, 0.4);\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5), 0 0 25px rgba(212, 164, 96, 0.12);\n}\n\n.inst-why-card-pattern {\n  position: absolute;\n  top: 0;\n  left: -10%;\n  width: 100%;\n  max-width: 480px;\n  height: 200px;\n  object-fit: contain;\n  object-position: top center;\n  pointer-events: none;\n  z-index: 1;\n  opacity: 1;\n}\n\n.inst-why-badge-wrap {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.inst-why-vector-img {\n  width: 200px;\n  object-fit: contain;\n  transition: transform 0.3s ease;\n}\n\n.inst-why-card:hover .inst-why-vector-img {\n  transform: scale(1.06);\n}\n\n.inst-why-card-title {\n  position: relative;\n  z-index: 2;\n  font-size: 28px;\n  font-weight: 600;\n  color: #ffffff;\n  line-height: 1.25;\n  text-align: center;\n  width: 100%;\n  min-height: 54px;\n  margin: 0 auto 15px;\n}\n\nbody.light_theme .inst-why-card-title {\n  color: #0f172a;\n}\n\n.inst-why-card-desc {\n  position: relative;\n  z-index: 2;\n  font-size: 14px;\n  font-weight: 400;\n  color: #A8ABB4;\n  line-height: 1.6;\n  text-align: center;\n  max-width: 360px;\n  margin: 0 auto;\n}\n\nbody.light_theme .inst-why-card-desc {\n  color: #64748b;\n}\n\n/* ==========================================================================\n   3. BUILT TO PASS YOUR DUE DILIGENCE SECTION\n   ========================================================================== */\n.inst-due-section {\n  position: relative;\n  padding: 90px 0px 100px;\n  background-color: #171A20;\n  background-image: url('../../../../public/images/infrastructure-img/built_diligencebg.jpg');\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: cover;\n  overflow: hidden;\n  color: #ffffff;\n}\n\nbody.light_theme .inst-due-section {\n  background-color: #f8fafc;\n  background-image: url('../../../../public/images/infrastructure-img/built_diligencebg_light.jpg');\n  color: #0f172a;\n}\n\n.inst-due-container {\n  position: relative;\n  z-index: 2;\n  max-width: 1480px;\n  padding: 0px 20px;\n  margin: 0 auto;\n}\n\n.inst-due-header-grid {\n  display: grid;\n  grid-template-columns: 1.15fr 0.85fr;\n  align-items: center;\n  gap: 40px;\n  margin-bottom: 58px;\n}\n\n.inst-due-title {\n  font-size: 60px;\n  font-weight: 700;\n  line-height: 1.15;\n  color: #ffffff;\n  margin-bottom: 18px;\n}\n\nbody.light_theme .inst-due-title {\n  color: #0f172a;\n}\n\n.inst-due-gold {\n  color: #D1AA67;\n}\n\n.inst-due-subtitle {\n  font-size: 22px;\n  line-height: 1.65;\n  color: #94A3B8;\n  max-width: 580px;\n  margin: 0;\n}\n\nbody.light_theme .inst-due-subtitle {\n  color: #475569;\n}\n\n.inst-due-graphic-wrap {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.inst-due-svg {\n  width: 100%;\n  max-width: 550px;\n  height: auto;\n  object-fit: contain;\n}\n\n.inst-due-cards-grid {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 20px;\n  align-items: stretch;\n}\n\n.inst-due-card {\n  position: relative;\n  background: rgb(255 255 255 / 10%);\n  border: 1px solid rgba(255, 255, 255, 0.20);\n  border-radius: 18px;\n  min-height: 341px;\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  -webkit-backdrop-filter: blur(12px);\n  backdrop-filter: blur(12px);\n  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1), border-color 0.3s ease, box-shadow 0.3s ease;\n}\n\nbody.light_theme .inst-due-card {\n  background: #ffffff;\n  border: 1px solid #f2f2f2;\n  box-shadow: 0 8px 24px rgb(0 0 0 / 12%);\n}\n\n.inst-due-card:hover {\n  transform: translateY(28px);\n  background: #D1AA67;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  z-index: 3;\n}\n\nbody.light_theme .inst-due-card:hover .cards_buitseffect {\n  background-color: rgb(0 0 0 / 5%);\n  border: 1px solid #e8e8e8;\n}\n\n.cards_buitseffect {\n  padding: 20px;\n  border-radius: 16px;\n  background-color: rgb(255 255 255 / 0%);\n  border: 1px solid #ffffff00;\n  height: 100%;\n}\n\n.inst-due-card:hover .cards_buitseffect {\n  background-color: rgb(255 255 255 / 10%);\n  border: 1px solid #fff;\n}\n\n.inst-due-card:hover .inst-due-icon-badge {\n  background-color: #fff;\n}\n\n.inst-due-card:hover .inst-due-icon-badge img {\n  filter: invert(1);\n}\n\n.inst-due-card:hover .inst-due-card-desc {\n  color: #ffffff;\n}\n\n.inst-due-dots-badge {\n  position: absolute;\n  top: 14px;\n  left: 18px;\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 14px;\n  letter-spacing: 2px;\n  font-weight: 700;\n}\n\n.inst-due-icon-badge {\n  width: 48px;\n  height: 48px;\n  background: #D1AA67;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 32px;\n}\n\n.inst-due-icon-img {\n  width: 26px;\n  height: 26px;\n  object-fit: contain;\n}\n\n.inst-due-card-title {\n  font-size: 24px;\n  font-weight: 600;\n  color: #ffffff;\n  line-height: 1.3;\n  margin-bottom: 18px;\n}\n\nbody.light_theme .inst-due-card-title {\n  color: #0f172a;\n}\n\n.inst-due-card-featured .inst-due-card-title {\n  color: #ffffff;\n}\n\n.inst-due-card-desc {\n  font-size: 16px;\n  line-height: 1.6;\n  color: #a6a6a6;\n  margin: 0;\n}\n\nbody.light_theme .inst-due-card-desc {\n  color: #64748b;\n}\n\nbody.light_theme .inst-due-card:hover .inst-due-card-desc {\n  color: #64748b;\n}\n\nbody.light_theme .inst-due-card:hover .inst-due-icon-badge {\n  background-color: #dddddd;\n}\n\n.inst-due-card-featured .inst-due-card-desc {\n  color: rgba(255, 255, 255, 0.95);\n}\n\n/* ==========================================================================\n   4. INSTITUTIONAL SOLUTIONS FOR EVERY MARKET SECTION\n   ========================================================================== */\n.inst-sol-section {\n  position: relative;\n  padding: 70px 0px 120px;\n  background: #171A20;\n  color: #ffffff;\n  overflow: hidden;\n}\n\nbody.light_theme .inst-sol-section {\n  background-color: #ffffff;\n  color: #0f172a;\n}\n\n.inst-sol-container {\n  position: relative;\n  z-index: 2;\n  max-width: 1480px;\n  margin: 0 auto;\n  padding: 0px 20px;\n}\n\n.inst-sol-grid {\n  display: grid;\n  grid-template-columns: 1fr 1.20fr;\n  gap: 42px;\n  align-items: center;\n}\n\n.inst-sol-graphic-col {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.inst-sol-graphic-wrap {\n  position: relative;\n  width: 100%;\n  max-width: 660px;\n}\n\n.inst-sol-img {\n  width: 100%;\n  height: auto;\n  display: block;\n  object-fit: contain;\n  filter: drop-shadow(0 20px 40px rgba(0, 0, 0, 0.4));\n}\n\n.inst-sol-text-col {\n  display: flex;\n  flex-direction: column;\n}\n\n.inst-sol-title {\n  font-size: 60px;\n  font-weight: 500;\n  line-height: 1;\n  color: #ffffff;\n  margin-bottom: 36px;\n}\n\nbody.light_theme .inst-sol-title {\n  color: #0f172a;\n}\n\n.inst-sol-gold {\n  color: #D1AA67;\n  font-weight: 700;\n}\n\n.inst-sol-table {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.inst-sol-table-header {\n  display: grid;\n  grid-template-columns: 270px 1fr;\n  padding-bottom: 14px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  font-size: 18px;\n  font-weight: 500;\n}\n\nbody.light_theme .inst-sol-table-header {\n  border-color: #e2e8f0;\n}\n\n.inst-sol-th-left {\n  color: #D1AA67;\n}\n\n.inst-sol-th-right {\n  color: #D1AA67;\n}\n\n.inst-sol-row {\n  display: grid;\n  grid-template-columns: 270px 1fr;\n  align-items: center;\n  padding: 18px 0;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.12);\n  transition: background 0.2s ease;\n}\n\nbody.light_theme .inst-sol-row {\n  border-color: #f1f5f9;\n}\n\n.inst-sol-row:hover {\n  background: rgba(255, 255, 255, 0.015);\n}\n\n.inst-sol-row:last-child {\n  border-bottom: none;\n}\n\n.inst-sol-cell-institution {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding-right: 16px;\n}\n\n.inst-sol-icon-badge {\n  width: 46px;\n  min-width: 46px;\n  height: 46px;\n  border-radius: 50%;\n  background: rgb(255 255 255 / 10%);\n  border: 1px solid rgb(255 255 255 / 18%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.inst-sol-icon-img {\n  width: 30px;\n  object-fit: contain;\n}\n\n.inst-sol-inst-name {\n  font-size: 18px;\n  font-weight: 500;\n  color: #ffffff;\n  line-height: 1.3;\n}\n\nbody.light_theme .inst-sol-inst-name {\n  color: #0f172a;\n}\n\n.inst-sol-cell-desc {\n  font-size: 18px;\n  line-height: 1.55;\n  color: #A7A7A7;\n}\n\nbody.light_theme .inst-sol-cell-desc {\n  color: #475569;\n}\n\n/* ==========================================================================\n   5. PROCESS BANNER\n   ========================================================================== */\n.inst-proc-banner {\n  margin-top: 70px;\n  background: rgb(255 255 255 / 5%);\n  border: 1px solid rgb(209 170 103 / 25%);\n  border-radius: 18px;\n  padding: 40px;\n  display: grid;\n  grid-template-columns: 420px 1fr;\n  gap: 40px;\n  align-items: center;\n  /* box-shadow: 0 20px 50px rgba(0, 0, 0, 0.4), inset 0 1px 1px rgba(255, 255, 255, 0.06); */\n  position: relative;\n  -webkit-backdrop-filter: blur(10px);\n  backdrop-filter: blur(10px);\n}\n\nbody.light_theme .inst-proc-banner {\n  background: rgb(0 0 0 / 5%);\n  border: 1px solid rgb(209 170 103 / 25%);\n  box-shadow: 0 10px 30px rgb(0 0 0 / 18%);\n}\n\n.inst-proc-left {\n  display: flex;\n  flex-direction: column;\n}\n\n.inst-proc-title {\n  font-size: 36px;\n  font-weight: 800;\n  line-height: 1.18;\n  color: #ffffff;\n  margin: 0 0 16px 0;\n}\n\nbody.light_theme .inst-proc-title {\n  color: #0f172a;\n}\n\n.inst-proc-gold {\n  color: #D1AA67;\n}\n\n.inst-proc-desc {\n  font-size: 16px;\n  line-height: 1.55;\n  color: #94A3B8;\n  margin: 0;\n}\n\nbody.light_theme .inst-proc-desc {\n  color: #64748b;\n}\n\n.inst-proc-steps {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 20px;\n  align-items: flex-start;\n}\n\n.inst-proc-step {\n  display: flex;\n  flex-direction: column;\n}\n\n.inst-proc-icon-wrap {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  margin-bottom: 20px;\n  position: relative;\n}\n\n.inst-proc-icon {\n  width: 52px;\n  min-width: 52px;\n  height: 52px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.10);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  box-shadow: inset 0 1px 1px rgba(255, 255, 255, 0.1);\n  transition: all 0.3s ease;\n}\n\nbody.light_theme .inst-sol-icon-badge {\n  background: rgb(132 132 132 / 10%);\n}\n\nbody.light_theme .inst-proc-icon {\n  background: rgb(0 0 0 / 5%);\n  border-color: #e7e7e7;\n}\n\nbody.light_theme .inst-cta-arch {\n  background: radial-gradient(ellipse at 50% 0%, rgba(212, 164, 96, 0.40) 0%, rgb(255 255 255 / 40%) 50%, rgb(255 255 255 / 0%) 80%);\n}\n\n.inst-proc-step:hover .inst-proc-icon {\n  background: rgba(212, 164, 96, 0.12);\n  border-color: rgba(212, 164, 96, 0.4);\n  box-shadow: 0 0 18px rgba(212, 164, 96, 0.25);\n  transform: scale(1.06);\n}\n\n.inst-proc-connector {\n  flex: 1;\n  height: 1px;\n  background: linear-gradient(90deg, rgba(212, 164, 96, 0.4), rgba(255, 255, 255, 0.1));\n  margin-left: 14px;\n}\n\n.inst-proc-step-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0 0 10px 0;\n}\n\nbody.light_theme .inst-proc-step-title {\n  color: #0f172a;\n}\n\n.inst-proc-step-desc {\n  font-size: 15px;\n  line-height: 1.5;\n  color: #94A3B8;\n  margin: 0;\n}\n\nbody.light_theme .inst-proc-step-desc {\n  color: #64748b;\n}\n\n/* ==========================================================================\n   6. SETTLEMENT CTA BOX\n   ========================================================================== */\n.inst-cta-box {\n  margin-top: 100px;\n  position: relative;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 140px 20px 40px;\n  overflow: hidden;\n}\n\n.inst-cta-arch {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: min(1360px, 100%);\n  height: 600px;\n  border-radius: 50% 50% 0 0 / 100% 100% 0 0;\n  border-top: 1.5px solid rgba(212, 164, 96, 0.45);\n  border-left: 1px solid rgba(212, 164, 96, 0.15);\n  border-right: 1px solid rgba(212, 164, 96, 0.15);\n  border-bottom: none;\n  background: radial-gradient(ellipse at 50% 0%, rgba(212, 164, 96, 0.32) 0%, rgba(25, 27, 36, 0.4) 50%, rgba(11, 12, 16, 0) 80%);\n  pointer-events: none;\n}\n\n.inst-cta-content {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  max-width: 680px;\n}\n\n.inst-cta-title {\n  font-size: 60px;\n  font-weight: 600;\n  line-height: 1.15;\n  color: #ffffff;\n  margin: 0 0 12px 0;\n}\n\nbody.light_theme .inst-cta-title {\n  color: #0f172a;\n}\n\n.inst-cta-subtitle {\n  font-size: 24px;\n  line-height: 1.55;\n  color: #9CA3AF;\n  margin: 0 0 30px 0;\n  max-width: 800px;\n}\n\nbody.light_theme .inst-cta-subtitle {\n  color: #475569;\n}\n\n.inst-cta-btns {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.inst-cta-btns button {\n  font-size: 20px;\n  font-weight: 600;\n  padding: 18px 35px;\n  border-radius: 100px;\n  border: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.inst-cta-btn-primary {\n  background: #d1aa67;\n  color: #0b0c10;\n\n}\n\n.inst-cta-btn-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 28px rgba(212, 164, 96, 0.45);\n  background: #deb978;\n}\n\n.inst-cta-btn-secondary {\n  background: #737373;\n  color: #ffffff;\n}\n\nbody.light_theme .inst-cta-btn-secondary {\n  background: rgba(0, 0, 0, 0.05);\n  color: #1e293b;\n  border-color: rgba(0, 0, 0, 0.1);\n}\n\n.inst-cta-btn-secondary:hover {\n  transform: translateY(-2px);\n  background: rgba(110, 110, 110, 0.95);\n  border-color: rgba(255, 255, 255, 0.35);\n}\n\n/* ==========================================================================\n   RESPONSIVE STYLES\n   ========================================================================== */\n\n@media (max-width: 1500px) {\n\n  .inst-hero-title {\n    font-size: 64px;\n  }\n\n  .inst-hero-description {\n    font-size: 22px;\n  }\n\n  .inst-hero-container {\n    max-width: 95%;\n  }\n\n  .inst-due-container {\n    max-width: 95%;\n  }\n\n  .inst-sol-container {\n    max-width: 95%;\n  }\n\n  .inst-cta-title {\n    font-size: 54px;\n  }\n\n  .inst-why-title {\n    font-size: 54px;\n  }\n\n  .inst-due-title {\n    font-size: 54px;\n  }\n\n  .inst-sol-title {\n    font-size: 54px;\n  }\n\n  .inst-why-container {\n    max-width: 95%;\n  }\n\n}\n\n\n@media (max-width: 1376px) {\n\n  .inst-hero-section {\n    padding: 40px 0px 50px;\n    min-height: 80vh;\n  }\n\n  .inst-hero-title {\n    font-size: 54px;\n  }\n\n  .inst-hero-description {\n    font-size: 18px;\n    margin-bottom: 24px;\n  }\n\n  .inst-hero-actions button {\n    font-size: 15px;\n    padding: 13px 24px;\n  }\n\n  .inst-cta-title {\n    font-size: 48px;\n  }\n\n  .inst-why-title {\n    font-size: 48px;\n  }\n\n  .inst-due-title {\n    font-size: 48px;\n  }\n\n  .inst-sol-title {\n    font-size: 48px;\n  }\n\n  .inst-due-subtitle {\n    font-size: 18px;\n  }\n\n  .inst-cta-btns button {\n    font-size: 16px;\n    padding: 14px 32px;\n  }\n\n  .inst-cta-subtitle {\n    font-size: 20px;\n    margin: 0 0 24px 0;\n  }\n\n}\n\n\n@media (max-width: 1200px) {\n\n\n  .inst-due-cards-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n\n  .inst-due-card-featured {\n    transform: none;\n  }\n\n  .inst-due-card-featured:hover {\n    transform: translateY(-5px);\n  }\n\n  .inst-proc-banner {\n    grid-template-columns: 1fr;\n    gap: 36px;\n    padding: 36px 32px;\n  }\n}\n\n@media (max-width: 1200px) {\n\n\n  .inst-hero-container {\n    gap: 24px;\n  }\n\n  .inst-hero-title {\n    font-size: 42px;\n  }\n\n\n  .inst-hero-img {\n    max-width: 400px;\n  }\n\n  .inst-hero-content {\n    max-width: 100%;\n  }\n\n  .inst-hero-section {\n    padding: 40px 0px !important;\n  }\n\n  .inst-hero-description {\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .inst-hero-actions button {\n    font-size: 14px;\n    padding: 12px 18px;\n  }\n\n  .inst-why-title {\n    font-size: 40px;\n    margin-bottom: 32px;\n  }\n\n  .inst-hero-graphic {\n    width: auto;\n  }\n\n  .inst-why-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 20px;\n  }\n\n  .inst-sol-grid {\n    gap: 24px;\n  }\n\n  .inst-sol-title {\n    font-size: 36px;\n  }\n\n  .inst-why-section {\n    padding: 60px 0px 80px;\n  }\n\n  .inst-due-title {\n    font-size: 40px;\n  }\n\n  .inst-due-section {\n    padding: 60px 0px 60px;\n  }\n\n  .inst-sol-section {\n    padding: 60px 0px 70px;\n  }\n\n  .inst-sol-cell-desc {\n    font-size: 15px;\n  }\n\n  .inst-sol-inst-name {\n    font-size: 15px;\n  }\n\n  .inst-cta-title {\n    font-size: 40px;\n  }\n\n  .inst-cta-subtitle {\n    font-size: 18px;\n  }\n\n}\n\n@media (max-width: 991px) {\n\n  .inst-hero-img {\n    max-width: 300px;\n  }\n\n  .inst-hero-title {\n    font-size: 36px;\n    margin-bottom: 18px;\n  }\n\n  .inst-hero-description {\n    font-size: 16px;\n  }\n\n  .inst-hero-container {\n    max-width: 100%;\n  }\n\n  .inst-why-title {\n    font-size: 32px;\n    margin-bottom: 24px;\n  }\n\n  .inst-why-card-title {\n    font-size: 20px;\n    min-height: 48px;\n  }\n\n  .inst-why-vector-img {\n    width: 150px;\n  }\n\n  .inst-why-container {\n    max-width: 100%;\n  }\n\n  .inst-due-title {\n    font-size: 32px;\n  }\n\n  .inst-due-subtitle {\n    font-size: 16px;\n  }\n\n  .inst-due-svg {\n    max-width: 400px;\n  }\n\n  .inst-sol-grid {\n    display: flex;\n    flex-direction: column-reverse;\n  }\n\n  .inst-sol-graphic-wrap {\n    max-width: 400px;\n  }\n\n  .inst-proc-title {\n    font-size: 32px;\n  }\n\n  .inst-due-header-grid {\n    grid-template-columns: 1fr;\n    gap: 30px;\n    text-align: center;\n  }\n\n  .inst-due-subtitle {\n    margin: 0 auto;\n  }\n\n  .inst-due-graphic-wrap {\n    justify-content: center;\n  }\n\n  .inst-due-cards-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .inst-proc-steps {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 28px;\n  }\n\n  .inst-proc-connector {\n    display: none;\n  }\n}\n\n@media (max-width: 768px) {\n  .inst-cta-box {\n    margin-top: 60px;\n    padding: 60px 16px 40px;\n  }\n\n  .inst-cta-title {\n    font-size: 30px;\n  }\n\n  .inst-cta-subtitle {\n    font-size: 14px;\n    margin-bottom: 28px;\n  }\n\n  .inst-cta-btns {\n    flex-wrap: nowrap;\n  }\n\n  .inst-cta-btn-primary,\n  .inst-cta-btn-secondary {\n    width: 100%;\n  }\n\n  .inst-cta-btns button {\n    font-size: 15px;\n    padding: 12px 18px;\n  }\n\n  .inst-cta-arch {\n    height: 280px;\n  }\n}\n\n@media (max-width: 767px) {\n\n  .inst-hero-container {\n    flex-direction: column;\n    text-align: center;\n    gap: 32px;\n  }\n\n  body #hero.inst-hero-section {\n    padding: 32px 0px !important;\n    border-radius: 0px;\n  }\n\n  .inst-why-section {\n    padding: 35px 0px 40px;\n  }\n\n  .inst-hero-title {\n    font-size: 26px;\n    margin-bottom: 14px;\n  }\n\n  .inst-hero-img {\n    max-width: 280px;\n  }\n\n  .inst-why-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .inst-sol-section {\n    padding: 35px 0px;\n  }\n\n  .inst-why-title {\n    font-size: 24px;\n    margin-bottom: 22px;\n  }\n\n  .inst-why-card {\n    padding: 24px;\n  }\n\n  .inst-sol-title {\n    font-size: 24px;\n    margin-bottom: 18px;\n    text-align: center;\n  }\n\n  .inst-sol-table-header {\n    display: none;\n  }\n\n  .inst-sol-row {\n    grid-template-columns: 1fr;\n    gap: 10px;\n    padding: 16px 0;\n  }\n\n  .inst-due-cards-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .inst-due-section {\n    padding: 35px 0px 35px;\n  }\n\n  .inst-proc-steps {\n    grid-template-columns: 1fr;\n    gap: 24px;\n  }\n\n  .inst-sol-cell-desc {\n    font-size: 14px;\n  }\n\n  .inst-sol-graphic-wrap {\n    max-width: 280px;\n  }\n\n  .inst-proc-banner {\n    gap: 24px;\n    padding: 24px;\n    text-align: center;\n    margin-top: 40px;\n  }\n\n  .inst-proc-icon-wrap {\n    justify-content: center;\n    margin-bottom: 15px;\n  }\n\n  .inst-due-card-title {\n    font-size: 20px;\n    margin-bottom: 12px;\n  }\n\n  .inst-due-card-desc {\n    font-size: 14px;\n  }\n\n  .inst-cta-arch {\n    border-radius: 0px;\n    border: none;\n  }\n\n  .inst-cta-box {\n    margin-top: 40px;\n    padding: 24px 16px 24px;\n  }\n\n  .inst-cta-title {\n    font-size: 24px;\n  }\n\n  .inst-cta-subtitle {\n    margin-bottom: 18px;\n  }\n\n  .inst-proc-title {\n    font-size: 24px;\n  }\n\n  .inst-proc-desc {\n    font-size: 15px;\n  }\n\n  .inst-due-title {\n    font-size: 24px;\n  }\n\n  .inst-due-subtitle {\n    font-size: 15px;\n  }\n\n  .inst-due-header-grid {\n    gap: 24px;\n    margin-bottom: 26px;\n  }\n\n  .inst-due-container {\n    max-width: 100%;\n  }\n\n  .inst-sol-container {\n    max-width: 100%;\n  }\n\n  .inst-hero-actions {\n    justify-content: center;\n  }\n\n\n}\n\n@media (max-width:480px) {\n\n  .inst-cta-btns {\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .inst-cta-btns button {\n    font-size: 14px;\n    padding: 10px 18px;\n  }\n\n  .inst-sol-row {\n    text-align: center;\n  }\n\n  .inst-sol-cell-institution {\n    justify-content: center;\n    flex-direction: column;\n    padding-right: 0px;\n  }\n\n  .inst-hero-title {\n    font-size: 24px;\n  }\n\n  .inst-hero-description {\n    font-size: 15px;\n    margin-bottom: 12px;\n  }\n\n  .inst-why-title {\n    font-size: 22px;\n    margin-bottom: 18px;\n  }\n\n  .inst-why-card-title {\n    font-size: 18px;\n    min-height: auto;\n  }\n\n  .inst-due-title {\n    font-size: 22px;\n    margin-bottom: 12px;\n  }\n\n  .inst-due-card-title {\n    font-size: 18px;\n  }\n\n  .inst-due-icon-badge {\n    margin-bottom: 20px;\n  }\n\n  .inst-sol-title {\n    font-size: 22px;\n  }\n\n  .inst-proc-title {\n    font-size: 22px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
